import { render } from "./imagepreview.vue?vue&type=template&id=6a42f5f8"
import script from "./imagepreview.vue?vue&type=script&lang=js"
export * from "./imagepreview.vue?vue&type=script&lang=js"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__